declare global {
  interface Window {
    BE_URL?: string;
  }
}

const API_PREFIX = (window.BE_URL ?? "") + "/api/v1";

export const API_URL = {
  // Auth
  AUTH: API_PREFIX + "/login",
  LOGOUT: API_PREFIX + "/logout",

  // Alert Calendar
  ALERT_CALENDAR: API_PREFIX + "/scheduler/alert-calendar",

  // Catalogs
  CATALOGS: API_PREFIX + "/catalogs",

  // Profiles
  PROFILES: API_PREFIX + "/profiles",

  // Mappings
  MAPPINGS: API_PREFIX + "/mappings",
  MAPPINGS_IMPORT: API_PREFIX + "/mappings/import",

  // Components
  COMPONENTS: API_PREFIX + "/components",
  COMPONENT_DEFINITIONS: API_PREFIX + "/component-definitions",

  // SSP (System Security Plans)
  SSP: API_PREFIX + "/ssps",

  // Assessments
  ASSESSMENT_PLANS: API_PREFIX + "/assessment-plans",
  ASSESSMENT_RESULTS: API_PREFIX + "/assessment-results",

  // POAM
  POAM: API_PREFIX + "/poams",
  POAM_LIST: API_PREFIX + "/poams",
  POAM_CREATE: API_PREFIX + "/poams",

  // Telemetry
  TELEMETRY: API_PREFIX + "/telemetry",

  // Governance
  GOVERNANCE: API_PREFIX + "/governance",

  // Audit Logs
  AUDIT_LOGS: API_PREFIX + "/audit-logs",

  // AI Assistant
  AI_ASSISTANT: API_PREFIX + "/ai-assistant",

  // AI Companion (Compliance Assistant chatbot)
  AI_COMPANION_CONVERSATIONS: API_PREFIX + "/ai/companion/conversations",
  AI_COMPANION_SUGGESTIONS: API_PREFIX + "/ai/companion/suggestions",

  // Users
  USERS: API_PREFIX + "/users",

  // Settings
  SETTINGS: API_PREFIX + "/settings",

  // Dashboard — Platform Owner
  DASHBOARD: API_PREFIX + "/dashboard",
  DASHBOARD_ASSETS: API_PREFIX + "/dashboard/platform-owner/assets",
  DASHBOARD_POAM: API_PREFIX + "/dashboard/platform-owner/poam",
  DASHBOARD_EXCEPTIONS: API_PREFIX + "/dashboard/platform-owner/exceptions",

  // Dashboard — CISO
  CISO_ALERTS: API_PREFIX + "/dashboard/ciso/alerts",
  CISO_KPIS: API_PREFIX + "/dashboard/ciso/kpis",
  CISO_COMPLIANCE_POSTURE: API_PREFIX + "/dashboard/ciso/compliance-posture",
  CISO_BU_HEATMAP: API_PREFIX + "/dashboard/ciso/bu-heatmap",
  CISO_COMPLIANCE_DRIFT: API_PREFIX + "/dashboard/ciso/compliance-drift",
  CISO_RISKS: API_PREFIX + "/dashboard/ciso/risks",
  CISO_AUDIT_READINESS: API_PREFIX + "/dashboard/ciso/audit-readiness",
  CISO_EXCEPTIONS_SUMMARY: API_PREFIX + "/dashboard/ciso/exceptions-summary",

  // Dashboard — Quadrant
  QUADRANT_METRICS: API_PREFIX + "/dashboard/quadrant/metrics",
  QUADRANT_ALERTS: API_PREFIX + "/dashboard/quadrant/alerts",
  QUADRANT_RISK_QUADRANT: API_PREFIX + "/dashboard/risk-quadrant",
  QUADRANT_RISK_MAP: API_PREFIX + "/dashboard/risk-quadrant/org-risk-map",
  QUADRANT_ENTITY_DETAILS: API_PREFIX + "/dashboard/risk-quadrant/applications",
  QUADRANT_WITHOUT_SSP: API_PREFIX + "/dashboard/risk-quadrant/without-ssp",
  QUADRANT_FINDINGS_DISTRIBUTION:
    API_PREFIX + "/dashboard/risk-quadrant/findings-distribution",
  QUADRANT_SUMMARY: API_PREFIX + "/dashboard/risk-quadrant/summary",
  
  QUADRANT_SCOPE_OPTIONS:
    API_PREFIX + "/dashboard/risk-quadrant/scope-options",

  QUADRANT_ORGANIZATIONS: API_PREFIX + "/dashboard/risk-quadrant/organizations",
  QUADRANT_ORG_SUMMARY:
    API_PREFIX + "/dashboard/risk-quadrant/organizations/summary",

  // Reports
  REPORTS_DASHBOARD: API_PREFIX + "/reports/dashboard",
  REPORTS_SSP: API_PREFIX + "/reports/ssp",

  // Dashboard — GRC Manager (legacy)
  GRC_ALERTS: API_PREFIX + "/dashboard/grc-manager/alerts",
  GRC_KPIS: API_PREFIX + "/dashboard/grc-manager/kpis",
  GRC_PIPELINE: API_PREFIX + "/dashboard/grc-manager/assessment-pipeline",
  GRC_COMPLIANCE_TREND: API_PREFIX + "/dashboard/grc-manager/compliance-trend",
  GRC_TEAM_PERFORMANCE: API_PREFIX + "/dashboard/grc-manager/team-performance",
  GRC_ACTIONS: API_PREFIX + "/dashboard/grc-manager/actions",

  // Dashboard — GRC Overview (v1)
  GRC_OV_SUMMARY: API_PREFIX + "/dashboard/grc/summary",
  GRC_OV_ASSESSMENT_PIPELINE: API_PREFIX + "/dashboard/grc/assessment-pipeline",
  GRC_OV_TOP_RISK_APPS: API_PREFIX + "/dashboard/grc/top-risk-applications",
  GRC_OV_FINDINGS_OVERVIEW: API_PREFIX + "/dashboard/grc/findings-overview",

  // Dashboard — GRC Group Level (v1)
  GRC_FILTER_SCOPE: API_PREFIX + "/dashboard/grc/filter-scope",
  GRC_GROUP_SUMMARY: API_PREFIX + "/dashboard/grc/group/summary",
  GRC_GROUP_ORGS: API_PREFIX + "/dashboard/grc/group/organizations",
  GRC_GROUP_TOP_RISK: API_PREFIX + "/dashboard/grc/group/top-risk-contributors",
  GRC_GROUP_PIPELINE: API_PREFIX + "/dashboard/grc/group/assessment-pipeline",

  AUDITOR_ENTITY_RISK: API_PREFIX + "/dashboard/auditor/entity-risk",
  AUDITOR_CONTROL_FAILURES: API_PREFIX + "/dashboard/auditor/control-failures",

  // Dashboard Widgets — catalog + per-user (v1)
  GRC_WIDGET_CATALOG: API_PREFIX + "/dashboard-widgets",
  GRC_MY_WIDGETS: API_PREFIX + "/dashboard/grc/my-widgets",
  // Config (admin) — role widgets per org: GET / PUT / DELETE
  //   GRC_ROLE_WIDGETS(orgId, roleId) + "/widgets/" + widget
  GRC_ROLE_WIDGETS: API_PREFIX + "/dashboard-widgets/orgs",

  // Identity Configuration
  IDENTITY_CONFIG: API_PREFIX + "/system/identity-config",
  IDENTITY_CONFIG_TEST: API_PREFIX + "/system/identity-config/test",

  // Organization Units
  ORG_UNITS: API_PREFIX + "/org-units",

  // Users (Admin)
  ADMIN_USERS: API_PREFIX + "/users",

  // Platform Roles & Group Mappings
  PLATFORM_ROLES: API_PREFIX + "/system/platform-roles",
  PLATFORM_ROLES_WITH_MAPPINGS: API_PREFIX + "/system/platform-roles/with-mappings",
  AVAILABLE_PERMISSIONS: API_PREFIX + "/system/platform-roles/permissions/available",
  GROUP_MAPPINGS: API_PREFIX + "/system/group-mappings",
  LDAP_GROUPS: API_PREFIX + "/ldap/groups",

  // Accessible Organizations
  ACCESSIBLE_ORGS: API_PREFIX + "/users/current/accessible-organizations",

  // Current User Permissions
  CURRENT_USER_PERMISSIONS: API_PREFIX + "/users/current/permissions",

  // LLM Configuration
  LLM_CONFIGS: API_PREFIX + "/ai/llm-configurations",
  LLM_CHAT: API_PREFIX + "/ai/llm-configurations/chat",
  AI_INTERACTION_CONTROLLER: API_PREFIX + "/ai/ai-module-assignments",

  // Validation Rules (per-org governance rules)
  VALIDATION_RULES: API_PREFIX + "/validation-rules",
  SEMANTIC_RULE_PACKS: API_PREFIX + "/semantic-rule-packs",
  SEMANTIC_RULES: API_PREFIX + "/content-registry/semantic-rules",
};

export const SEMANTIC_RULE_PACKS_URL = {
  publish: (id: string) => `${API_URL.SEMANTIC_RULE_PACKS}/${id}/publish`,
};

// ─── Log Review (SIRAR) ──────────────────────────────────────────────────────
// Log Review is served by its own backend service, mounted under a distinct
// path prefix on the same origin as the main API — so it deploys independently
// without needing a second host global. The Division → Application → Category
// cascade is the one exception: it lives on the CMDB service, scoped by org.

const LOG_REVIEW_PREFIX = (window.BE_URL ?? "") + "/cag/api/v1";

export const LOG_REVIEW_URL = {
  /** Base for every SIRAR endpoint — one edit here moves the whole module. */
  SIRAR: LOG_REVIEW_PREFIX + "/sirar",
  FILTER: LOG_REVIEW_PREFIX + "/Filter",
  /** Top filter-bar cascade, shared by all three Log Review screens. */
  FILTER_TREE: LOG_REVIEW_PREFIX + "/Filter/getSirarFilter",
};


// Dashboard URL helpers
export const DASHBOARD_URL = {
  assets: (sspId: string) => `${API_URL.DASHBOARD_ASSETS}?ssp_id=${sspId}`,
  assetFindings: (inventoryItemId: string, sspId: string) =>
    `${API_URL.DASHBOARD_ASSETS}/${inventoryItemId}/findings?ssp_id=${sspId}`,
};

// POAM URL helpers for dynamic routes
export const POAM_URL = {
  detail: (id: string) => `${API_URL.POAM}/${id}`,
  items: (poamId: string) => `${API_URL.POAM}/${poamId}/items`,
  itemCreate: (poamId: string) => `${API_URL.POAM}/${poamId}/items`,
  remediation: (poamId: string, itemId: string) =>
    `${API_URL.POAM}/${poamId}/items/${itemId}/remediation`,
  riskAdjustment: (poamId: string, itemId: string) =>
    `${API_URL.POAM}/${poamId}/items/${itemId}/risk-adjustments`,
  submitMonthly: (poamId: string) => `${API_URL.POAM}/${poamId}/submit-monthly`,
};

// Reports URL helpers
export const REPORTS_URL = {
  dashboard: API_URL.REPORTS_DASHBOARD,
  summary: (sspId: string) => `${API_URL.REPORTS_SSP}/${sspId}/summary`,
  html: (sspId: string) => `${API_URL.REPORTS_SSP}/${sspId}/html`,
};

// AI Module Configuration URL helpers (per-org module → provider assignments)
export const AI_INTERACTION_CONTROLLER_URL = {
  forOrg: (orgId: string) =>
    `${API_URL.AI_INTERACTION_CONTROLLER}?orgId=${encodeURIComponent(orgId)}`,
  assignableProviders: (orgId: string) =>
    `${API_URL.AI_INTERACTION_CONTROLLER}/assignable-providers?orgId=${encodeURIComponent(orgId)}`,
  bulk: `${API_URL.AI_INTERACTION_CONTROLLER}/bulk`,
  // Single-module update — PUT { orgId, aiModule, configId }. Touches only the
  // edited module so the other modules' assignments are never cleared.
  single: API_URL.AI_INTERACTION_CONTROLLER,
};

// ─── AI / LLM shared UI constants ───────────────────────────────────────────

/**
 * localStorage key holding the selected organization for the AI Module
 * Configuration. Uses the same "llm-configurations:org" slot as the LLM
 * Configuration screen so the chosen organization stays in sync across both.
 */
export const LLM_ORG_STORAGE_KEY = "llm-configurations:org";

/**
 * Display order for the AI Module Configuration module rows. Validation and
 * Content Registry were merged into a single Document Validation module, Reports
 * was renamed to Report, and AI Companion / Executive Insights are newer modules.
 */
export const AI_MODULE_ORDER = [
  "VALIDATION",
  "CONTENT_REGISTRY",
  "EXECUTIVE_INSIGHTS",
  "REPORTS",
  "AI_COMPANION",
] as const;

/**
 * Cosmetic accent color per provider enum for the AI Module Configuration
 * table (labels always come from the API). Unknown providers fall back to
 * AI_PROVIDER_ACCENT_DEFAULT.
 */
export const AI_PROVIDER_ACCENT_COLORS: Record<string, string> = {
  ANTHROPIC: "text-yellow-600 dark:text-yellow-400",
  OPENAI: "text-emerald-600 dark:text-emerald-400",
  AZURE_OPENAI: "text-blue-600 dark:text-blue-400",
  BEDROCK: "text-orange-600 dark:text-orange-400",
  GEMINI: "text-purple-600 dark:text-purple-400",
  LOCAL_LLM: "text-cyan-600 dark:text-cyan-400",
  GROQ: "text-pink-600 dark:text-pink-400",
  NVIDIA_NIM: "text-green-600 dark:text-green-400",
};
export const AI_PROVIDER_ACCENT_DEFAULT = "text-blue-600 dark:text-blue-400";

/** Placeholder shown for any display value that is null / omitted from the API. */
export const EMPTY_PLACEHOLDER = "-";
